import { Cancel as CancelIcon } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import MDTypography from "components/MDTypography";
import ApplicantActions from "./ApplicantActions";

const InterviewApplicantRow = ({
  row,
  idx,
  onRemove,
  applicants,
  onClickRow,
  refetchApplicants,
  customAttachments,
  customTemplates,
  onChangeFeedback,
}) => {
  const { id, firstName, lastName, email, phone } = row ?? {};

  const isNew = !applicants?.find((applicant) => {
    const applicantId = applicant.id || applicant._id;
    return applicantId === id;
  });

  return (
    <>
      <Grid container alignItems="center" spacing={2} onClick={isNew ? () => {} : onClickRow}>
        <Grid item sm={8.5}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item sm={3}>
              <MDTypography variant="body2">{`${firstName} ${lastName}`}</MDTypography>
            </Grid>
            <Grid item sm={5}>
              <MDTypography variant="body2">{email}</MDTypography>
            </Grid>
            <Grid item sm={4}>
              <MDTypography textAlign="start" variant="body2">
                {phone}
              </MDTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={3.5} sx={{ display: "flex", justifyContent: "flex-end" }}>
          {!isNew ? (
            <ApplicantActions
              id={id}
              parentComponent="Applicant"
              row={row}
              onRemove={() => onRemove(idx)}
              refetchApplicants={refetchApplicants}
              customAttachments={customAttachments}
              customTemplates={customTemplates}
              onChangeFeedback={onChangeFeedback}
            />
          ) : (
            <IconButton
              sx={{ p: 0 }}
              onClick={(e) => {
                e.stopPropagation();
                onRemove(idx);
              }}
            >
              <CancelIcon color="error" fontSize="medium" />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default InterviewApplicantRow;
